// Backstop poll only — correctness during normal use comes from the SignalR "board changed"
// nudge + reconnect-refetch. The poll matters only when the socket is down (staleness ≤30s).
export const SPLITS_POLL_MS = 30_000;

// Max length of a character's splits note (mirrors SplitRules.MaxNoteLength on the backend).
export const MAX_NOTE_LENGTH = 200;

// Cursor relay tuning.
export const CURSOR_THROTTLE_MS = 50; // ~20 frames/s
export const CURSOR_STALE_MS = 10_000; // drop a cursor we haven't heard from (missed Left/CursorHidden)

// Build-time literals (see build.ts / apiClient.ts). Bare references throw in dev, so guard with `typeof`.
declare const __API_BASE_URL__: string;
declare const __PWA__: boolean;

// The SignalR client connects cross-origin to the backend. In prod it mirrors the API base
// (__API_BASE_URL__, empty → same-origin). In dev it connects directly to the backend on :5142,
// bypassing the Bun proxy (which does not upgrade WebSockets) — mirroring prod's cross-origin path.
export function splitsHubUrl(): string {
  const isProd = typeof __PWA__ !== "undefined" && __PWA__;
  if (isProd) {
    const base =
      typeof __API_BASE_URL__ !== "undefined" ? __API_BASE_URL__ : "";
    return `${base}/hub/splits`;
  }
  return "http://localhost:5142/hub/splits";
}
